import { render, staticRenderFns } from "./SettingsAccountModal.vue?vue&type=template&id=4c7dffce&scoped=true&"
import script from "./SettingsAccountModal.vue?vue&type=script&lang=js&"
export * from "./SettingsAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAccountModal.vue?vue&type=style&index=0&id=4c7dffce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7dffce",
  null
  
)

export default component.exports